import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_LOOKUP_CATEGORY_OK = "GET_LOOKUP_CATEGORY_OK";
export const GET_LOOKUP_CATEGORY_ERR = "GET_LOOKUP_CATEGORY_ERR";

export const lookupCategoryAction = {
  getLookupCategory,
};

function getLookupCategoryOk(payload) {
  return { type: GET_LOOKUP_CATEGORY_OK, payload };
}
function getLookupCategoryErr(payload) {
  return { type: GET_LOOKUP_CATEGORY_ERR, payload };
}

function getLookupCategory(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetLookupCategoryAdm)
      .then((response) => {
        dispatch(getLookupCategoryOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getLookupCategoryErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
